import React from 'react';
import { useEffect, useState, useCallback } from "react";
import ContentArea from "../components/content-area/Content";
import { getPortals } from '../api/portalApi';
import PortalLinksList from '../components/portals/PortalLinksList';
import PortalPng from "../assets/icons/portal.png";
import { useSpaceId } from "../hooks/useSpaceId";
import { signalRService } from '../services/signalRService';
import { SIGNALR_EVENTS } from '../constants/signalREvents';
import { CONTENT_TYPES } from '../constants/contentTypes';

function Portal() {
  const spaceId = useSpaceId();
  const [portals, setPortals] = useState([]);

  const loadPortals = useCallback(async () => {
    try {
      const data = await getPortals();
      setPortals(data);
    } catch (err) {
      console.error('[load error]', err);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!spaceId) return;
    loadPortals();
  }, [spaceId, loadPortals]);

  useEffect(() => {
    const handleDecision = (payload) => {
      if (payload?.contentType === CONTENT_TYPES.PORTAL) loadPortals();
    };
    signalRService.on(SIGNALR_EVENTS.APPROVAL_DECISION, handleDecision);
    return () => signalRService.off(SIGNALR_EVENTS.APPROVAL_DECISION, handleDecision);
  }, [loadPortals]);

  useEffect(() => {
    const handleWithdrawn = (payload) => {
      if (payload?.contentType === CONTENT_TYPES.PORTAL) loadPortals();
    };
    signalRService.on(SIGNALR_EVENTS.APPROVAL_WITHDRAWN, handleWithdrawn);
    return () => signalRService.off(SIGNALR_EVENTS.APPROVAL_WITHDRAWN, handleWithdrawn);
  }, [loadPortals]);

  return (
    <ContentArea title="Portal" icon={PortalPng}>
      <PortalLinksList portals={portals} onRefresh={loadPortals} />
    </ContentArea>
  );
}

export default Portal;
